import { render, staticRenderFns } from "./ReviewsSettingsCellRendererContact.vue?vue&type=template&id=e82a263e&scoped=true&"
import script from "./ReviewsSettingsCellRendererContact.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettingsCellRendererContact.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsSettingsCellRendererContact.vue?vue&type=style&index=0&id=e82a263e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82a263e",
  null
  
)

export default component.exports